module.exports = __webpack_public_path__ + "img/okrView.d65ec4dd.png";